export default __webpack_public_path__ + "static/media/rocket_anim_27.f4d6e14e.png";